import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './Home/home';

function App() {
  return (
    <BrowserRouter basename="/enroll">
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
